import { render, staticRenderFns } from "./SpiderChartReport.vue?vue&type=template&id=180023da&scoped=true&ref=SpiderChartReport"
import script from "./SpiderChartReport.vue?vue&type=script&lang=js"
export * from "./SpiderChartReport.vue?vue&type=script&lang=js"
import style0 from "./SpiderChartReport.vue?vue&type=style&index=0&id=180023da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180023da",
  null
  
)

export default component.exports